
import React from "react";
import "../styles/home.css";
import "../styles/global.css";

export default function Home() {
  return (
    <main className="home-page"
        style={{
          backgroundImage: 'url("/imagens/textura-hexagono-azul.png")'
        }}
    >
      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="home-hero">

        <div
          className="home-hero-slide"
          style={{
            backgroundImage: 'url("/imagens/hero-evento-tech.png")',
          }}
        />

        <div className="home-hero-overlay" />

        <div className="home-hero-content">

          <div className="home-hero-line" />

          <h1>
            Tecnologia que transforma
            <span> eventos.</span>
          </h1>

          <p>
            Soluções completas de credenciamento para eventos,
            desenvolvidas para proporcionar agilidade, segurança
            e uma experiência profissional.
          </p>

          <a
            href="#solucoes"
            className="home-hero-button"
          >
            CONHEÇA NOSSAS SOLUÇÕES
            <span>→</span>
          </a>

        </div>

        <div className="home-scroll">
          <span>SCROLL</span>
          <div />
        </div>

      </section>


      {/* =====================================================
          INTRODUÇÃO
      ===================================================== */}

      <section className="home-intro">

        <div className="home-container">

          <span className="home-section-label">
            SCHUZERTI
          </span>

          <div className="home-intro-grid">

            <div className="home-intro-title">

              <h2>
                Tecnologia para
                <br />
                <span>eventos.</span>
              </h2>

            </div>

            <div className="home-intro-text">

              <p>
                Oferecemos soluções completas de credenciamento
                para eventos, unindo tecnologia, agilidade e
                segurança.
              </p>

              <p>
                Nosso objetivo é proporcionar uma experiência
                diferenciada para organizadores, expositores e
                visitantes, tornando cada etapa do processo mais
                simples, rápida e eficiente.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          SOLUÇÕES
      ===================================================== */}

      <section
        className="home-services"
        id="solucoes"
      >

        <div className="home-container">

          <div className="home-section-header">

            <div>

              <span className="home-section-label">
                O QUE FAZEMOS
              </span>

              <h2>
                Uma solução para
                <br />
                <span>cada etapa.</span>
              </h2>

            </div>

            <p>
              Estruturamos o credenciamento de forma
              inteligente, utilizando tecnologia para
              facilitar o trabalho da organização e melhorar
              a experiência dos participantes.
            </p>

          </div>


          <div className="home-services-grid">

            <div className="home-service-card">

              <div className="home-service-icon">
                <img
                  src="/imagens/icone-credenciamento.png"
                  alt="Credenciamento"
                />
              </div>

              <h3>
                Credenciamento
              </h3>

              <p>
                Cadastro e identificação dos participantes
                de forma rápida e organizada.
              </p>

            </div>


            <div className="home-service-card">

              <div className="home-service-icon">
                <img
                  src="/imagens/icone-seguranca.png"
                  alt="Segurança"
                />
              </div>

              <h3>
                Segurança
              </h3>

              <p>
                Controle das informações e processos
                desenvolvidos pensando na segurança do evento.
              </p>

            </div>


            <div className="home-service-card">

              <div className="home-service-icon">
                <img
                  src="/imagens/icone-agilidade.png"
                  alt="Agilidade"
                />
              </div>

              <h3>
                Agilidade
              </h3>

              <p>
                Atendimento eficiente para reduzir filas
                e melhorar o fluxo de entrada.
              </p>

            </div>


            <div className="home-service-card">

              <div className="home-service-icon">
                <img
                  src="/imagens/icone-tecnologia.png"
                  alt="Tecnologia"
                />
              </div>

              <h3>
                Tecnologia
              </h3>

              <p>
                Equipamentos e sistemas modernos adaptados
                às necessidades de cada evento.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          ONDE ATUAMOS
      ===================================================== */}

      <section className="home-location">

        <div className="home-container">

          <div className="home-location-grid">

            <div className="home-location-content">

              <span className="home-section-label">
                ONDE ATUAMOS
              </span>

              <h2>
                Presença no
                <br />
                <span>Sul do Brasil.</span>
              </h2>

              <p>
                Estamos presentes em diferentes formatos
                e portes de eventos.
              </p>

              <div className="home-states">
                <span>PR</span>
                <span>SC</span>
                <span>RS</span>
              </div>

            </div>


            <div className="home-location-visual">

              <div className="home-grid-decoration" />

              <div className="home-location-circle">

                <div className="home-location-center">
                  <strong>3</strong>
                  <span>ESTADOS</span>
                </div>

              </div>

              <div className="home-location-point point-pr">
                <span />
                PARANÁ
              </div>

              <div className="home-location-point point-sc">
                <span />
                SANTA CATARINA
              </div>

              <div className="home-location-point point-rs">
                <span />
                RIO GRANDE DO SUL
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          COMO É FEITO
      ===================================================== */}

      <section className="home-process">

        <div className="home-container">

          <div className="home-section-header">

            <div>

              <span className="home-section-label">
                COMO É FEITO
              </span>

              <h2>
                Do planejamento
                <br />
                <span>ao evento.</span>
              </h2>

            </div>

            <p>
              Cada projeto é preparado de acordo com as
              características e necessidades específicas
              do evento.
            </p>

          </div>


          <div className="home-process-line">

            <div className="home-process-item">

              <span>01</span>

              <div>
                <h3>Planejamento</h3>

                <p>
                  Entendemos o formato do evento e definimos
                  a melhor estrutura de credenciamento.
                </p>
              </div>

            </div>


            <div className="home-process-item">

              <span>02</span>

              <div>
                <h3>Configuração</h3>

                <p>
                  Personalizamos o sistema
                  de acordo com a identidade
                  do evento.
                </p>
              </div>

            </div>


            <div className="home-process-item">

              <span>03</span>

              <div>
                <h3>Operação</h3>

                <p>
                  Nossa equipe acompanha o funcionamento
                  do credenciamento durante o evento.
                </p>
              </div>

            </div>


            <div className="home-process-item">

              <span>04</span>

              <div>
                <h3>Resultado</h3>

                <p>
                  Mais organização, agilidade e uma melhor
                  experiência para os participantes.
                </p>
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          TECNOLOGIAS
      ===================================================== */}

      <section className="home-technologies">

        <div className="home-container">

          <span className="home-section-label">
            TECNOLOGIA
          </span>

          <div className="home-tech-title">

            <h2>
              Infraestrutura
              <br />
              <span>confiável.</span>
            </h2>

            <p>
              Utilizamos ferramentas e plataformas modernas
              para garantir estabilidade, segurança e
              escalabilidade aos sistemas utilizados nos
              eventos.
            </p>

          </div>


          <div className="home-tech-grid">

            <div className="home-tech-card">

              <div className="home-tech-logo">

                <img
                  src="/imagens/BDLogo.png"
                  alt="Firebase Cloud Firestore"
                />

              </div>

              <div>

                <span>DATABASE</span>

                <h3>
                  Cloud Firestore
                </h3>

                <p>
                  Banco de dados moderno e escalável utilizado
                  para o armazenamento e gerenciamento seguro
                  das informações.
                </p>

              </div>

            </div>


            <div className="home-tech-card">

              <div className="home-tech-logo">

                <img
                  src="/imagens/NFLogo.png"
                  alt="Netlify"
                />

              </div>

              <div>

                <span>INFRASTRUCTURE</span>

                <h3>
                  Netlify
                </h3>

                <p>
                  Plataforma de hospedagem utilizada para
                  disponibilizar nossos sistemas com
                  infraestrutura automatizada e escalável.
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          CTA
      ===================================================== */}

      <section className="home-cta">

        <div className="home-container">

          <div className="home-cta-box">

            <div>

              <span className="home-section-label">
                SCHUZERTI
              </span>

              <h2>
                Vamos fazer seu
                <br />
                evento acontecer.
              </h2>

              <p>
                Entre em contato e conheça nossas soluções
                para credenciamento de eventos.
              </p>

            </div>

          <a
            href="https://wa.me/5541999424036?text=Olá!%20Vi%20o%20site%20da%20Schutzer%20TI%20e%20gostaria%20de%20conhecer%20melhor%20as%20soluções%20de%20credenciamento%20para%20eventos."
            className="home-cta-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            ENTRE EM CONTATO
            <span>→</span>
          </a>

          </div>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ===================================================== */}

      <footer className="home-footer">

        <div className="home-container">

          <div className="home-footer-top">

            <div className="home-footer-brand">

              <div className="home-brand">
                <span>Schutzer</span>
                <strong>TI</strong>
              </div>

              <div className="home-brand-subtitle">
                credenciamento e recepção de eventos.
              </div>

            </div>


            <div className="home-footer-column">

              <h4>Contato</h4>

              <a href="mailto:schutzerti@gmail.com">
                schutzerti@gmail.com
              </a>

            </div>


            <div className="home-footer-column">

              <h4>Atuação</h4>

              <p>Paraná</p>
              <p>Santa Catarina</p>
              <p>Rio Grande do Sul</p>

            </div>


            <div className="home-footer-column">

              <h4>Serviços</h4>

              <p>Credenciamento</p>
              <p>Recepção</p>
              <p>Tecnologia para eventos</p>

            </div>

          </div>


          <div className="home-footer-bottom">

            <span>
              2026 SchutzerTI.
            </span>
            <span>
              CREDENCIAMENTO DE EVENTOS
            </span>

          </div>

        </div>

      </footer>

    </main>
  );
}

